import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { getAuthenticatedUser } from 'ACTIONS/auth.actions';
import { Button } from 'antd';
import './withAuthorization.less';

const withAuthorization = (WrappedComponent) => {
  class AuthComponent extends Component {
    componentDidMount() {
      if (!this.props.currentUser) {
        this.props.getAuthenticatedUser();
      }
    }

    render() {
      if (this.props.isAuthLoading || !this.props.currentUser) {
        return (
          <div className="auth-verifying">
            <Button shape="circle" loading />
            <span className="message">Verifying user...</span>
          </div>
        );
      }

      return <WrappedComponent {...this.props} isAuthenticated={Boolean(this.props.currentUser)} />;
    }
  }

  AuthComponent.defaultProps = {
    isAuthLoading: true,
    currentUser: null,
  };

  AuthComponent.propTypes = {
    getAuthenticatedUser: PropTypes.func.isRequired,
    isAuthLoading: PropTypes.bool,
    currentUser: PropTypes.object,
  };

  const mapStateToProps = ({ auth }) => auth;

  const enhance = compose(connect(mapStateToProps, { getAuthenticatedUser }));

  return enhance(AuthComponent);
};

export default withAuthorization;



// WEBPACK FOOTER //
// ./src/helpers/withAuthorization/withAuthorization.js